module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/078-belize-af2c9b139b57446085f2e72750db7e5c.svg";